import { services } from '@octadesk-tech/services'
import { getParameterHeaders } from './headers'

const getClient = () => {
  const headers = getParameterHeaders()
  return services.createClient('widgetBff', { headers })
}

export const getCompanyModel = () =>
  getClient()
    .then(client => client.get('/company/model'))
    .then(r => r.data)

export const getCulture = () =>
  getClient()
    .then(client => client.get('/company/culture'))
    .then(r => r.data || 'pt-BR')
